import React from 'react';
import { ACTIVITY_TYPES } from '../activityTypes.js';

export function ActivityIcon({ type }) {
    if (type === ACTIVITY_TYPES.PHONE_CALL) {
        return (
            <svg viewBox="0 0 48 48" aria-hidden="true">
                <path
                    d="M16 10c-2 1-4 5-4 8 0 9 9 18 18 18 4 0 7-2 8-4l-6-6c-1-1-2-1-3 0l-2 2c-4-2-7-5-9-9l2-2c1-1 1-2 0-3l-4-4z"
                    fill="currentColor"
                />
                <path
                    d="M30 12c4 1 7 4 8 8M30 18c2 1 3 2 4 4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                />
            </svg>
        );
    }

    if (type === ACTIVITY_TYPES.CHECK_IN) {
        return (
            <svg viewBox="0 0 48 48" aria-hidden="true">
                <rect
                    x="9"
                    y="10"
                    width="22"
                    height="28"
                    rx="3"
                    fill="currentColor"
                    opacity="0.55"
                />
                <rect x="14" y="15" width="5" height="5" rx="1" fill="white" />
                <rect x="22" y="15" width="5" height="5" rx="1" fill="white" />
                <rect x="14" y="24" width="5" height="5" rx="1" fill="white" />
                <path d="M34 19c-5 0-9 4-9 9 0 7 9 13 9 13s9-6 9-13c0-5-4-9-9-9z" fill="#22b45f" />
                <circle cx="34" cy="28" r="3" fill="white" />
            </svg>
        );
    }

    if (type === ACTIVITY_TYPES.VIDEO_CHECK_IN) {
        return (
            <svg viewBox="0 0 48 48" aria-hidden="true">
                <rect
                    x="8"
                    y="15"
                    width="22"
                    height="16"
                    rx="4"
                    fill="currentColor"
                    opacity="0.7"
                />
                <path d="M30 21l10-5v18l-10-5z" fill="currentColor" opacity="0.7" />
                <path d="M18 20c-5 0-9 4-9 9 0 7 9 13 9 13s9-6 9-13c0-5-4-9-9-9z" fill="#22b45f" />
                <circle cx="18" cy="29" r="3" fill="white" />
            </svg>
        );
    }

    if (type === ACTIVITY_TYPES.FAST_CHECK_IN) {
        return (
            <svg viewBox="0 0 48 48" aria-hidden="true">
                <path
                    d="M10 18h14M8 25h16M12 32h12"
                    fill="none"
                    stroke="#22b45f"
                    strokeWidth="4"
                    strokeLinecap="round"
                />
                <path
                    d="M32 13c-6 0-10 4-10 10 0 8 10 15 10 15s10-7 10-15c0-6-4-10-10-10z"
                    fill="currentColor"
                    opacity="0.72"
                />
                <circle cx="32" cy="23" r="3" fill="white" />
            </svg>
        );
    }

    if (type === ACTIVITY_TYPES.VIDEO_CALL) {
        return (
            <svg viewBox="0 0 48 48" aria-hidden="true">
                <rect x="8" y="15" width="25" height="18" rx="5" fill="currentColor" />
                <path d="M33 21l9-5v16l-9-5z" fill="currentColor" />
            </svg>
        );
    }

    if (type === ACTIVITY_TYPES.WHATSAPP) {
        return (
            <svg viewBox="0 0 48 48" aria-hidden="true">
                <path
                    d="M24 7c-9 0-16 7-16 16 0 3 1 6 2 8l-2 8 8-2c2 1 5 2 8 2 9 0 16-7 16-16S33 7 24 7z"
                    fill="currentColor"
                />
                <path
                    d="M18 16c-1 1-2 3-2 5 0 5 6 11 11 11 2 0 4-1 5-2l-4-4c-1-1-1-1-2 0l-1 1c-2-1-4-3-5-5l1-1c1-1 1-1 0-2l-3-3z"
                    fill="white"
                />
            </svg>
        );
    }

    if (type === ACTIVITY_TYPES.EMAIL) {
        return (
            <svg viewBox="0 0 48 48" aria-hidden="true">
                <rect
                    x="7"
                    y="13"
                    width="34"
                    height="24"
                    rx="4"
                    fill="currentColor"
                    opacity="0.88"
                />
                <path
                    d="M7 16l17 12L41 16"
                    fill="none"
                    stroke="white"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );
    }

    return (
        <svg viewBox="0 0 48 48" aria-hidden="true">
            <rect x="7" y="13" width="34" height="24" rx="4" fill="currentColor" opacity="0.88" />
            <path
                d="M7 16l17 12L41 16"
                fill="none"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
